import bankData from "@constant/bank.json";

import React from "react";
import { Select } from "antd";

export interface BankSelectValue {
  value: string;
  label: string;
}

type Props = {
  value?: BankSelectValue | string;
  onChange?: (value: BankSelectValue | string) => void;
  onBankCodeChange?: (bankCode: string) => void; // 額外 side effect
  labelInValue?: boolean;
  disabled?: boolean;
};

const BankList = (props: Props) => {
  const { value, onChange, onBankCodeChange, labelInValue, disabled } = props;
  const triggerChange = (option: BankSelectValue | string) => {
    onChange?.(option);

    if (typeof option === "object") {
      onBankCodeChange?.(option.value);
    } else {
      onBankCodeChange?.(option);
    }
  };

  const headBankName = bankData
    .filter((item) => !item.branchCode)
    .map((item) => ({
      bankName: item.bankName,
      bankCode: item.bankCode,
    }))
    .map((info: { bankCode: string; bankName: string }) => ({
      value: info.bankCode,
      label: info.bankName,
    }));

  return (
    <Select
      showSearch
      labelInValue={labelInValue}
      value={value}
      style={{ width: "100%" }}
      onChange={triggerChange}
      filterOption={(input, option: any) => option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      placeholder="請選擇"
      options={headBankName}
      disabled={disabled}
    />
  );
};

export default BankList;
